import * as React from "react";
import AuthService from "../../Components/auth/AuthService";
import Autocomplete from '@mui/material/Autocomplete';
import { Box } from "@mui/system";
import Stack from '@mui/material/Stack';
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { useLoadingDispatch, showLoading, hideLoading } from '../../context/loadingContext';
import { locationTypes, yesNo } from "../../Components/common/Constants";
import { Button, Row, Col, Input, Select, message, Descriptions, Tag, Flex, Table, Tooltip, Modal, Divider } from "antd";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import moment from "moment";
import { decodeId, formatCurrency } from "../../Components/common/CommonFun";
import { netsuite_url } from "../../Components/config";
import { ArrowLeftOutlined, CalendarOutlined, EyeOutlined, FileDoneOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { showMessage } from "../../Components/Utils/message";
import dayjs from "dayjs";
import InfoCards from "../../Components/InfoCards";
import DetailsGrid from "../../Components/common/DetailsGrid";

const Auth = new AuthService();

export default function TransactionsSaleOrder(props) {

  const navigate = useNavigate();
  const params = useParams();
    const decodedID = decodeId(params?.id)

  const { Option } = Select
  var layoutDispatch = useLoadingDispatch();
  const dispatch = useDispatch()
  const { products, locations, roles } = useSelector((state) => state?.AppState?.userCreds);
  const hasRole5 = roles?.some(r => r.role_id === 5);


  const [id, setId] = React.useState(decodedID ? decodedID : 0);
  const [order, setOrder] = React.useState([]);

  const [productDetail, setProductDetails] = React.useState([]);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [selectedProduct, setSelectedProduct] = React.useState('');

  const getDataByID = async () => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/stock/sales-order-details?id=${id}`);
      if (res.ack) {
        setOrder(res?.sales_order)
      } else {
        setOrder([])
        showMessage('error', res?.message)
      }
    } catch (error) {
      showMessage('error',"Something went wrong");
    } finally {
      hideLoading(layoutDispatch);
    }

  }

  React.useEffect(() => {
    if (id > 0) {
      getDataByID()
    }


  }, []);

  const getProductDetails = async (record) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/stock/sales-order-product-details?product_netsuite_id=${record?.product_netsuite_id}&netsuite_transaction_id=${record?.internal_id}`);
      if (res.ack) {
        setProductDetails(res?.sale_order_locations)
        const item = products?.find((item) => item.netsuite_id == record?.product_netsuite_id);
        setSelectedProduct(item)
        setModalOpen(true);
      } else {
        setProductDetails([]);
        setSelectedProduct('')
      }
    } catch (error) {
      showMessage('error',"Something went wrong");
    } finally {
      hideLoading(layoutDispatch);
    }
  }

  const dataCol = [
    
    {
      title: "Product",
      render(record) {
        const item = products?.find((item) => item.netsuite_id == record?.product_netsuite_id);

        return (
          <span>{item ? `${item?.code} - ${item?.name}` : '-'}</span>
        )

      }
    },
    {
      title: "Category",
      render(record) {
        const item = products?.find((item) => item.netsuite_id == record?.product_netsuite_id);

        return (
          <span>{item ? `${item?.sub_category}` : '-'}</span>
        )

      }
    },
    {
      title: 'Ordered Qty',
      render: (record) => {
        return <span>{record?.ordered_quantity?.toLocaleString() || '0'}</span>;
      },
    },
    {
      title: 'Invoiced Qty',
      render: (record) => {
        return <span>{record?.invoiced_quantity?.toLocaleString() || '0'}</span>;
      },
    },
    {
      title: 'Fullfilled Qty',
      render: (record) => {
        return <span>{record?.fulfilled_quantity?.toLocaleString() || '0'}</span>;
      },
    },
    {
      title: 'Dispatched Qty',
      render: (record) => {
        return <Tag color='error' style={{ fontSize: 16, fontWeight: 'bold' }}>{Number(record?.dispatched_quantity)?.toLocaleString() || 0} </Tag>;
      },
    },
    {
      title: 'Unit Price',
      render: (record) => {
        return (
          <>
            <span>{formatCurrency(record.unit_price) || ''}</span>
          </>
        )
      },
      width: 100
    },

    {
      title: 'Action',
      key: 'action',
      align: 'right',
      render: (text, record) => (
        <div>

          <EyeOutlined
            style={{
              fontSize: "25px",
              cursor: "pointer",
              marginRight: "5px",
              color: "#006cb8",
            }}
            onClick={() => getProductDetails(record)}
          />
        </div>
      )
    },


  ]
  const productDetailsCol = [

    {
      title: "Location",
      render(record) {
        const item = locations?.find((item) => item.id == record?.location_id);
        return (
          <span>{item ? `${item?.code}` : '-'}</span>
        )
      }
    },
    {
      title: 'Quantity',
      render: (record) => {
        return <Tag color='error' style={{ fontSize: 16, fontWeight: 'bold' }}>{Number(record?.quantity)?.toLocaleString() || 0} </Tag>;
      },
    },
    {
      title: 'Batch Code',
      render: (record) => {
        return <span>{record?.batch_code ? record?.batch_code : ""}</span>;
      },
    },
    {
      title: 'Supplier Batch Code',
      render: (record) => {
        return <span>{record?.supplier_batch_code ? record?.supplier_batch_code : ""}</span>;
      },
    },
    {
              title: "Expiry",
              render: (record) => {
                const expiry = record?.expiry_date;
                if (!expiry) return "";
        
                const expiryDate = dayjs(expiry, "YYYY-MM-DD");
                const today = dayjs();
                const diffDays = expiryDate.diff(today, "day");
        
                let color = "green";
                if (diffDays < 0) {
                  color = "red";
                } else if (diffDays <= 7) {
                  color = "orange";
                }
        
                return <Tag style={{ fontSize: '15px' }} color={color}>{dayjs(expiry).format('DD-MM-YYYY')}</Tag>;
              }
            },
    {
  title: "User",
  render(record) {
    if (!record) return "";

    const user = record?.user_name || "";
    const helper = record?.helper_name || "";

    if (helper) {
      return (
        <>
          {helper}{" "}
          {user && (
            <Tooltip title={`${user}`}>
              <InfoCircleOutlined style={{ fontSize: 16, marginLeft: 6, color: "#1890ff" }} />
            </Tooltip>
          )}
        </>
      );
    }

    return <>{user}</>;
  }
},
    {
            title: 'Created At',
            render: (record) => {
              return <span>{record?.createdAt ? moment(record?.createdAt).format("DD-MM-YYYY HH:mm:ss") : ""}</span>;
            },
          },
         

  ]

  const infoItems = [
      {
          label: 'Order No.',
          type: 'link',
          icon: <FileDoneOutlined  style={{ color: "#1677ff" }}/>,
          value: order[0]?.order_number ? (
            <>
            {
              hasRole5 ? (
                <span>{order[0]?.order_number}</span>
              ) : (
                <Tooltip title={"View Sale Order"} placement="top">
              <a
                  href={`${netsuite_url}/app/accounting/transactions/salesord.nl?id=${order[0]?.internal_id}`}
                  target="_blank"
                  rel="noopener noreferrer"
              >
                  {order[0]?.order_number}
              </a>
          </Tooltip>
              )
            }
            </>
          ) : '-',
      }, 
      {
          label: 'Posting Date',
          icon: <CalendarOutlined style={{ color: "#fa541c" }} />,
          type: 'text',
          value: order[0]?.posting_date ? dayjs(order[0]?.posting_date).format('DD-MM-YYYY') : '-'
      }
  ]

  return (
    <div>
       <Flex justify="space-between" align="center">
        <h3>Sales Order Details</h3>
        <Button
          onClick={() => navigate(`/transaction-so`)}
          icon={<ArrowLeftOutlined />}
        >
          Back
        </Button>
      </Flex>
      {/* <InfoCards items={infoItems} /> */}
      <DetailsGrid infoItems={infoItems}  />
      <Table
        dataSource={order}
        pagination={false}
        columns={dataCol}
        scroll={{ x: "max-content" }}
        rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
      />
      <Modal
        title={selectedProduct ? `Product Locations: ${selectedProduct?.code} - ${selectedProduct?.name}` : 'Product Details'}
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        width={1000}
        footer={null}
      >
        <>
          <Divider />
          <Table
            dataSource={productDetail}
            pagination={false}
            columns={productDetailsCol}
            style={{ marginTop: "10px" }}
            scroll={{ x: "max-content" }}
            rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
          />
        </>


      </Modal>
    </div>
  );
}

